import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    containerStyle,
    formContainerStyle,
    headerStyle,
    titleStyle,
    subtitleStyle,
    formStyle,
    errorStyle,
    linkStyle,
    buttonStyle,
    footerTextStyle,
    inputStyle
} from '../styles/globalStyles';

const MachineIDs = () => {
    const [machineId, setMachineId] = useState('');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [existingMachineIds, setExistingMachineIds] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        fetchMachineIds();
    }, [] );

    const fetchMachineIds = async () => {
        try{
            const token = localStorage.getItem('token');

            if( ! token ){
                navigate('/');

                return;
            }

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/machine-ids/`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if( response.ok ){
                const data = await response.json();

                setExistingMachineIds( data.machine_ids );
            } else {
                const errorData = await response.json();
                setError(errorData.detail || 'Failed to fetch machine IDs');
            }
        } catch (err) {
            setError('Failed to fetch machine IDs');
        }
    };

    const handleDelete = async (machineIdToDelete) => {
        try{
            const token = localStorage.getItem('token');

            if (!token) {
                navigate('/');
                return;
            }

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/machine-ids/${machineIdToDelete}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.ok) {
                setMessage('Machine ID deleted successfully');
                // Refresh the list
                await fetchMachineIds();
            } else {
                const errorData = await response.json();

                setError(errorData.detail || 'Failed to delete machine ID');
            }
        } catch (err) {
            setError('An error occurred while deleting the machine ID');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');

        if (!machineId.trim()) {
            setError('Please enter a machine ID');
            return;
        }
        
        setIsLoading(true);

        try{
            const token = localStorage.getItem('token');

            if( ! token ){
                navigate('/');
                return;
            }

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/machine-ids/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    machine_identifier: machineId
                }),
            });

            if( ! response.ok ){
                const errorData = await response.json();
                let errorMsg = errorData.detail;
                if (Array.isArray(errorMsg)) {
                    errorMsg = errorMsg.map(e => e.msg || JSON.stringify(e)).join(', ');
                } else if (typeof errorMsg === 'object') {
                    errorMsg = JSON.stringify(errorMsg);
                }
                setError(errorMsg || 'Failed to save machine ID. Please try again.');
                return;
            }

            setMessage('Machine ID added successfully!');
            setMachineId('');
            // Refresh the list
            await fetchMachineIds();
        } catch (err) {
            setError('An error occurred. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div style={containerStyle}>
            <div style={formContainerStyle}>
                <div style={headerStyle}>
                    <h1 
                        onClick={() => navigate('/')} 
                        style={{ ...titleStyle, cursor: 'pointer', transition: 'color 0.2s' }}
                        onMouseOver={(e) => e.target.style.color = '#22d3ee'}
                        onMouseOut={(e) => e.target.style.color = '#fff'}
                    >REAL TRADER</h1>
                    <div style={subtitleStyle}>Launch it and let it go.</div>
                
                    <h1 style={titleStyle}>Machine IDs</h1>
                </div>

                <form onSubmit={handleSubmit} style={formStyle}>
                    {message && (
                        <div style={{
                            color: '#22d3ee',
                            fontSize: 14,
                            textAlign: 'center',
                            marginBottom: 8,
                        }}>
                            {message}
                        </div>
                    )}
                    {error && (
                        <div style={errorStyle}>
                            {error}
                        </div>
                    )}
                    <div style={{ display: 'flex', gap: 8 }}>
                        <input 
                            placeholder="Machine ID"
                            style={inputStyle}
                            value={machineId}
                            onChange={(e) => setMachineId(e.target.value)}
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        style={{
                            ...buttonStyle,
                            opacity: isLoading ? 0.7 : 1,
                        }}
                        disabled={isLoading}
                    >
                        {isLoading ? 'ADDING...' : '+ ADD MACHINE ID'}
                    </button>

                    {/* Display existing machine IDs */}
                    {existingMachineIds.length > 0 && (
                        <div style={{ marginTop: 20 }}>
                            <h3 style={{ color: '#fff', marginBottom: 10 }}>Your Machine IDs ({existingMachineIds.length}/2)</h3>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                {existingMachineIds.map((machine) => (
                                    <div 
                                        key={machine.id} 
                                        style={{ 
                                            display: 'flex', 
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            padding: '8px 12px',
                                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                            borderRadius: 4
                                        }}
                                    >
                                        <span style={{ color: '#fff' }}>{machine.machine_identifier}</span>
                                        <button
                                            onClick={() => handleDelete(machine.id)}
                                            style={{
                                                ...buttonStyle,
                                                padding: '4px 8px',
                                                fontSize: 12,
                                                backgroundColor: '#ef4444'
                                            }}
                                        >
                                            Delete
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    <div style={footerTextStyle}>
                        <span style={linkStyle} onClick={() => navigate('/')}>Back to Login</span>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default MachineIDs; 